var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"flex content-center justify-center"},[_c('ffh-crosse'),_c('div',{staticClass:"text-h1"},[_vm._v("Page introuvable :-(")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }